import { ROUTE_NAME } from '@constants';

const useInformation = {
  path: '/use-information',
  redirect: '/use-information/user-guide',
  meta: {
    // isDesktop: true,
    breadcrumb: true,
    breadcrumbName: '운영안내',
    navMenu: true,
    description: '고객 여러분께 보다 나은 서비스를 제공하겠습니다.',
  },
  children: [
    {
      name: ROUTE_NAME.UserGuide,
      path: 'user-guide',
      component: () => import('@views/use-information/UserGuide.vue'),
      meta: {
        breadcrumb: true,
        breadcrumbName: '이용안내',
      },
    },
    {
      name: ROUTE_NAME.FeeInfo,
      path: 'fee-info',
      component: () => import('@views/use-information/FeeInfo.vue'),
      meta: {
        breadcrumb: true,
        breadcrumbName: '요금안내',
      },
    },
    {
      name: ROUTE_NAME.MatchInfo,
      path: 'match-info',
      component: () => import('@views/use-information/MatchInfo.vue'),
      meta: {
        breadcrumb: true,
        breadcrumbName: '경기안내',
      },
    },
    {
      name: ROUTE_NAME.ResourceLibrary,
      path: 'resource-library',
      component: () => import('@views/use-information/ResourceLibrary.vue'),
      meta: {
        breadcrumb: true,
        breadcrumbName: '자료실',
      },
    },
    {
      name: ROUTE_NAME.PrivacyPolicy,
      path: 'privacy-policy',
      component: () => import('@views/use-information/PrivacyPolicy.vue'),
      meta: {
        breadcrumb: true,
        breadcrumbName: '개인정보보호책임',
      },
    },
    // {
    //   name: ROUTE_NAME.SiteMap,
    //   path: 'site-map',
    //   component: () => import('@views/main/Sitemap.vue'),
    //   meta: {
    //     breadcrumb: true,
    //     breadcrumbName: '사이트맵',
    //   },
    // },
  ],
};
export default useInformation;
